
export default function SponsorsSection() {
  const sponsors = [
    { name: 'Mutua levante', src: '/assets/img/custom-images/patrocinadores/ad002_mutualevante.jpeg' },
    { name: 'El nostre - Ciutat', src: '/assets/img/custom-images/patrocinadores/ad008_elnostre.png' },
    { name: 'Camelot', src: '/assets/img/custom-images/patrocinadores/ad004_camelot.png' },
    { name: 'Olehidráulica Jordá', src: '/assets/img/custom-images/patrocinadores/ad009_olehidraulicajorda.png' },
    { name: 'Ascensores Byon', src: '/assets/img/custom-images/patrocinadores/ad006_byon.png' },
    { name: 'Economy Supermercados', src: '/assets/img/custom-images/patrocinadores/ad007_economy.png' },
    { name: 'Quality Tours Mariola', src: '/assets/img/custom-images/patrocinadores/ad010_qualitytoursmariola.jpg' },
    { name: 'Domus Vi', src: '/assets/img/custom-images/patrocinadores/ad011_domusvi.jpg' },
    { name: 'Cafés Barsel', src: '/assets/img/custom-images/patrocinadores/ad012_barsel.png' },
    { name: 'Mindanao', src: '/assets/img/custom-images/patrocinadores/ad013_mindanao.png' },
    { name: 'TuttoPiccolo', src: '/assets/img/custom-images/patrocinadores/ad014_tutopicolo.png' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Nuestros Patrocinadores</h2>
          <p className="text-lg text-gray-600">Gracias a todos los que hacen posible el Campamento Real</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center">
          {sponsors.map((sponsor, index) => (
            <div key={index} className="flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
              <img
                src={sponsor.src}
                alt={sponsor.name}
                className="max-h-16 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
